import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, input, linkedSignal, model, Output } from '@angular/core';
import { NgClass } from '@angular/common';

import { FileDragDropDirective, MediumZoomDirective } from '@shared/directives';
import { AlertService } from '@shared/services';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-file-upload-preview',
  imports: [FileDragDropDirective, NgClass, MediumZoomDirective, NgbTooltip],
  templateUrl: './file-upload-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploadPreviewComponent {
  private readonly alertService = inject(AlertService);

  @Output() cleared = new EventEmitter<void>();

  label = input<string>('Subir archivo');
  esVideo = input<boolean>(false);
  labelForId = input<string>('fileUpload');
  icon = input<string>('upload_file');
  title = input<string>('Arrastra y suelta un archivo aquí');
  isRequired = input<boolean>(false);
  isReadonly = input<boolean>(false);

  allowedFiles = input.required<string>();
  extensions = input.required<string>();

  fileMaxSize = input<number>(10_000_000);
  file = model<File | null>(null);

  imageUrl = input<string | null>(null);
  fileName = input<string | null>(null);

  attachmentName = linkedSignal(this.fileName);

  fileMaxSizeMb = computed(() => this.fileMaxSize() / 1_000_000);

  previewUrl = computed(() => {
    const file = this.file();

    if (!file && this.imageUrl()) {
      return this.imageUrl();
    }

    if (!file) {
      return null;
    }

    return URL.createObjectURL(file);
  });

  isImage = computed(() => this.file()?.type.startsWith('image/'));
  isVideoFile = computed(() => this.file()?.type.startsWith('video/'));

  uploadFileDrop(fileList: FileList) {
    const file = fileList[0];
    this.validarFile(file);
  }

  uploadFile(event: Event) {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];

    if (file) {
      this.validarFile(file);
    }

    target.value = '';
  }

  validarFile(file: File) {
    const allowedFiles = this.allowedFiles().replace(/\s/g, '');

    if (!allowedFiles.split(',').includes(file.type)) {
      this.alertService.showMessageCustom(
        'Advertencia',
        'El tipo de archivo no es permitido',
        { icon: 'brightness_alert', class: 'text-warning' }
      );
      return;
    }

    if (file.size > this.fileMaxSize()) {
      this.alertService.showMessageCustom(
        'Advertencia',
        `El archivo supera el límite permitido (${this.fileMaxSizeMb()}mb)`,
        { icon: 'brightness_alert', class: 'text-warning' }
      );
      return;
    }

    this.file.set(file);
  }

  clearFile() {
    this.file.set(null);
    this.attachmentName.set(null);
    this.cleared.emit();
  }

}
